import { connectedStore } from '../../store';
import getServiceAPIUrl from '../selectors/service-api-url';

const getAPIUrl = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getServiceAPIUrl(state);
};

export default getAPIUrl;
